export default {
  namespaced: true,

  state: () => ({
    token: '',
    receiptToken: ''
  }),

  mutations: {
    setTPassToken(state, data){
      console.log('savet oken:', data);
      state.token = data;
    },
  },

  getters: {
    getTPassToke(state) {
      return state.token;
    },
  },
};
